import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { GuestMoveService } from '../guest-move.service';
import { GuestMove } from '../guest-move';
import { GuestMoveComponent } from '../guest-move/guest-move.component';

@Component({
    selector: 'app-guest-move-list',
    templateUrl: './guest-move-list.component.html',
    styleUrls: ['./guest-move-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class GuestMoveListComponent implements OnInit {
	constructor(
		private guestMoveService: GuestMoveService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = guestMoveService.statuses;
	}

	@Input() orderId: number;
	@Input() reservationId: number;
  @Input() showFilter = true;

	// data
	guestMoves: any;
	guestMove: GuestMove;
	showPaginator = false;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		// { field: 'guestMoveId', header: 'Id', width: 'auto' },
		{ field: 'orderId', header: 'OrderId', width: 'auto', sorting: false },
		{ field: 'srcMoveDate', header: 'Source Move Date Time', width: 'auto', sorting: false },
		{ field: 'scrPropertyCode', header: 'Source Property Code', width: 'auto', sorting: false },
		{ field: 'destMoveDate', header: 'Destination Move Date Time', width: 'auto', sorting: false },
		{ field: 'destPropertyCode', header: 'Destination Property Code', width: 'auto', sorting: false },
		{ field: 'moveReason', header: 'Move Reason', width: 'auto',sorting: false },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.guestMoveId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-guestMove-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			if (this.orderId) {

				// if an orderId is passed as an input into the component, ONLY guestMoves for this orderId will be returned.
				let orderIdFilter = { 'orderId': { 'value': this.orderId, 'matchMode': 'in' } };
				Object.assign(event.filters, orderIdFilter);
			}
			
			if (this.reservationId) {
				// Create a custom OR-style filter parameter
				let orFilter = {
					'orReservationId': {
						value: this.reservationId,
						matchMode: 'or',
						fields: ['srcReservationVO.reservationId', 'destReservationVO.reservationId']
					}
				};
				Object.assign(event.filters, orFilter);
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.guestMoveService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.guestMoves = res.data.guestMoves;
						if(this.guestMoves.length < event.rows){
							this.showPaginator = false;
						}else{
							this.showPaginator = true;
						}
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.guestMoves = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return;
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(guestMove: GuestMove) {
		try {
			this.formLoading = true;
			this.guestMoveService.update(guestMove)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.guestMoves.map((guestMove, i) => {
							if (guestMove.guestMoveId === res.data.guestMove.guestMoveId) {
								this.guestMoves[i] = res.data.guestMove;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(guestMove: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(guestMove));

			this.formLoading = true;
			this.guestMoveService.delete(guestMove.guestMoveId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.guestMoves.splice(this.guestMoves.indexOf(guestMove), 1);
						this.recordTotal = this.guestMoves.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'GuestMove ' + guestMove.guestMoveId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'GuestMove ' + guestMove.guestMoveId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.width = '90%';

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Guest Move',
			orderId: this.orderId,
			srcReservationId: this.reservationId,
			reservationId: this.reservationId
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(GuestMoveComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addGuestMoveCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(guestMove: GuestMove) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.width = '90%';

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			guestMove: guestMove,
			title: 'Edit Guest Move',
			reservationId: this.reservationId
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(GuestMoveComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateGuestMoveCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteGuestMoveCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addGuestMoveCB(guestMove: GuestMove) {
		console.log('Adding GuestMove: ' + JSON.stringify(guestMove));
		// if we don't have a guestMoves array yet...
		if (!this.guestMoves) {
			this.guestMoves = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.guestMoves.unshift(guestMove);

		// no idea what this is but it is required to update the array
		this.guestMoves = [...this.guestMoves];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'GuestMove ' + guestMove.guestMoveId + ' Added', life: 3000 });
	}

	updateGuestMoveCB(guestMove: GuestMove) {
		console.log('Updating GuestMove: ' + JSON.stringify(guestMove));
		let itemIndex = this.guestMoves.findIndex((item: any) => item.guestMoveId === guestMove.guestMoveId);
		this.guestMoves[itemIndex] = guestMove;

		// no idea what this is but it is required to update the array
		this.guestMoves = [...this.guestMoves];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'GuestMove ' + guestMove.guestMoveId + ' Updated', life: 3000 });
	}

	deleteGuestMoveCB(guestMove: GuestMove) {
		console.log('Removing GuestMove: ' + guestMove);
		this.guestMoves.splice(this.guestMoves.indexOf(guestMove), 1);
		this.recordTotal = this.guestMoves.length;

		// no idea what this is but it is required to update the array
		this.guestMoves = [...this.guestMoves];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'GuestMove ' + guestMove.guestMoveId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.guestMoves ? this.first === (this.guestMoves.length - this.rows) : true; }
	isFirstPage(): boolean { return this.guestMoves ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(guestMove: any) {
		if (guestMove?.status) {
			const status = this.statuses.find((e: any) => e.value == guestMove.status);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		window.location.reload();
	}
}
